import React from "react"
//import { useStaticQuery, graphql } from "gatsby"
//import EventCarouselTabs from "components/Blocks/EventCarousel/EventCarouselTabs"

const EventCarousel = () => {
	/*
	 * commented this out 23/08/2019 becuase it was stopping the site from building. 
	 * Was workng previusly so must be something the client has updated on the APAI. 
	 * It's returning data so not sure what the issue is:
	 * https://staging.jacc-kw.com/wp-json/jacc/events/get-active-events
	 */
	/*
    const data = useStaticQuery(graphql`
        query {
            allWordpressJaccGetActiveEvents {
                edges {
                    node {
                        id
                    }
                }
            }
        }
    `)

    return(
        <EventCarouselTabs data={data} />
    )*/
	return null;
}

export default EventCarousel